import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'orders', // 资源路径
    defaultRels: ['orderProducts', 'member', 'refundRecord', 'activity'], // 默认需要的关联数据
  }

})
